import { useLocation, Navigate } from "react-router-dom";
// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography } from '@mui/material';
// components
import Page from '../../../components/Page';
import GenerateInstallationReportDetails from "../../../components/SidebarMenuComponents/OAComponent/GenerateInstallationReportDetails";
import IssueDeliveryDateDetails from "../../../components/SidebarMenuComponents/OtherComponent/IssueDeliveryDateDetails";
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
export default function IssueDeliveryDateDetailsPage() {
    const location = useLocation();
    const { issueDeliveryDate } = location.state;

    return (
        <Page title="Issue Delivery Date Details| tiketic" >
            <Typography variant="h5" color="#E7000B" marginLeft={3} marginTop={1} >
               Issue Delivery Date Details
            </Typography>

            <ContentStyle>
                <IssueDeliveryDateDetails issueDeliveryDate={issueDeliveryDate } />
            </ContentStyle>
        </Page>
    );
}

